<template>
  <div class="file_upload_box">
    <!-- 视频 -->
    <van-uploader class="video_upload" type="file" accept="video/*" v-model="videoList" v-if="data.fileType==1" :multiple="data.uploadLength>1" :max-count="data.uploadLength" :after-read="afterVideoRead" :before-delete="deleteVideo" @click-preview="previewVideoHandler">
      <template #preview-cover="{ }">
        <div class="preview-cover van-ellipsis">
          <van-icon name="play-circle-o" />
        </div>
      </template>
    </van-uploader>
    <!-- 音频 -->
    <van-uploader class="audio_upload" type="file" accept="audio/*" v-model="audioList" v-else-if="data.fileType==2" :multiple="data.uploadLength>1" :max-count="data.uploadLength" :after-read="afterAudioRead" :before-delete="deleteAudio" @click-preview="previewAudioHandler">
      <template #preview-cover="{ }">
        <div class="preview-cover van-ellipsis">
          <van-icon name="volume-o" />
        </div>
      </template>
    </van-uploader>
    <!-- 图片 -->
    <van-uploader type="file" accept="image/*" v-model="picList" v-else-if="data.fileType==3" :multiple="data.uploadLength>1" :max-count="data.uploadLength" :after-read="afterImgsRead" :before-delete="deleteImgs"></van-uploader>
    <!-- 视频预览 -->
    <div class="video_preview_dialog" v-if="showVideo">
      <div class="video_preview_box">
        <video controls controlslist="nodownload" disablepictureinpicture :src="videoSrc"></video>
      </div>
      <i role="button" class="van-icon van-icon-cross van-popup__close-icon van-popup__close-icon--top-right" @click="closeVideo"></i>
    </div>
    <!-- 音频预览 -->
    <div class="audio_preview_dialog" v-if="showAudio">
      <div class="audio_preview_box">
        <audio controls controlslist="nodownload" disablepictureinpicture :src="audioSrc"></audio>
      </div>
      <i role="button" class="van-icon van-icon-cross van-popup__close-icon van-popup__close-icon--top-right" @click="closeAudio"></i>
    </div>
  </div>
</template>
<script>
import { deepClone } from "@/utils";
import UploadServer from "@/api/apis/upload.js";
export default {
  name: "Upload",
  props: {
    data: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      firstLoad: true, // 是否第一次加载
      resourceObj: null, // 初始化时传入的上传资源列表
      maxSize: 5 * 1024 * 1024, //5M大小
      picList: [], // 图片列表
      audioList: [], // 音频列表
      videoList: [], // 视频列表
      picResourceIdList: [], // 上传的图片 resourceId 列表
      audioResourceIdList: [], // 上传的音频 resourceId 列表
      videoResourceIdList: [], // 上传的视频 resourceId 列表
      showVideo: false, // 是否显示视频预览
      showAudio: false, // 是否显示音频预览
      videoSrc: "", // 视频播放地址
      audioSrc: "", // 音频播放地址
    };
  },
  watch: {
    data: {
      handler(newValue, oldVue) {
        if (this.firstLoad && this.resourceObj == null) {
          this.resourceObj = deepClone(newValue);
          this.resourceObj.files.forEach(function (file, i) {
            file["id"] = file.resourceId;
          });
          if (this.resourceObj.fileType == 1) {
            this.videoList = this.resourceObj.files;
            this.videoResourceIdList = this.resourceObj.resourceIdList;
          } else if (this.resourceObj.fileType == 2) {
            this.audioList = this.resourceObj.files;
            this.audioResourceIdList = this.resourceObj.resourceIdList;
          } else if (this.resourceObj.fileType == 3) {
            this.picList = this.resourceObj.files;
            this.picResourceIdList = this.resourceObj.resourceIdList;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    /* 上传图片 */
    uploadPic(file) {
      var _this = this;
      UploadServer.fetchUploadPic(
        file.file,
        function (percentage) {
          file.message = percentage;
        },
        function (res) {
          if (res.suc == 1) {
            _this.picResourceIdList.push(res.resourceId);
            _this.$emit("uploadData", {
              index: _this.index,
              type: 3,
              list: _this.picResourceIdList,
              fileList: _this.picList,
            });
            file.url = res.url;
            file.id = res.resourceId;
            file.status = "done";
            file.message = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        }
      );
    },
    /* 上传图片 自行将文件上传至服务器 */
    afterImgsRead(file) {
      var _this = this;
      if (file instanceof Array) {
        for (var i = 0; i < file.length; i++) {
          let item = file[i];
          item.status = "uploading";
          item.message = "上传中...";
          _this.uploadPic(item);
        }
      } else {
        file.status = "uploading";
        file.message = "上传中...";
        _this.uploadPic(file);
      }
      _this.$emit("uploadData", {
        index: _this.index,
        type: 3,
        list: _this.picResourceIdList,
        fileList: _this.picList,
      });
    },
    /* 移除图片 */
    deleteImgs(file) {
      var _this = this;
      var index = _this.picResourceIdList.indexOf(file.id);
      if (index > -1) {
        _this.picResourceIdList.splice(index, 1);
        _this.picList.splice(index, 1);
        _this.$emit("uploadData", {
          index: _this.index,
          type: 3,
          list: _this.picResourceIdList,
          fileList: _this.picList,
        });
      }
    },
    /* 上传音频 */
    uploadAudio(file) {
      var _this = this;
      UploadServer.fetchUploadAudio(
        file.file,
        function (percentage) {
          file.message = percentage;
        },
        function (res) {
          if (res.suc == 1) {
            _this.audioResourceIdList.push(res.resourceId);
            _this.$emit("uploadData", {
              index: _this.index,
              type: 2,
              list: _this.audioResourceIdList,
              fileList: _this.audioList,
            });
            file.url = res.url;
            file.id = res.resourceId;
            file.status = "done";
            file.message = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        }
      );
    },
    /* 上传音频 自行将文件上传至服务器 */
    afterAudioRead(file) {
      var _this = this;
      if (file instanceof Array) {
        for (var i = 0; i < file.length; i++) {
          let item = file[i];
          item.status = "uploading";
          item.message = "上传中...";
          _this.uploadAudio(item);
        }
      } else {
        file.status = "uploading";
        file.message = "上传中...";
        _this.uploadAudio(file);
      }
      _this.$emit("uploadData", {
        index: _this.index,
        type: 2,
        list: _this.audioResourceIdList,
        fileList: _this.audioList,
      });
    },
    /* 移除音频 */
    deleteAudio(file) {
      var _this = this;
      var index = _this.audioResourceIdList.indexOf(file.id);
      if (index > -1) {
        _this.audioResourceIdList.splice(index, 1);
        _this.audioList.splice(index, 1);
        _this.$emit("uploadData", {
          index: _this.index,
          type: 2,
          list: _this.audioResourceIdList,
          fileList: _this.audioList,
        });
      }
    },
    /* 上传视频 */
    uploadVideo(file) {
      var _this = this;
      UploadServer.fetchUploadVideo(
        file.file,
        function (percentage) {
          file.message = percentage;
        },
        function (res) {
          if (res.suc == 1) {
            _this.videoResourceIdList.push(res.resourceId);
            _this.$emit("uploadData", {
              index: _this.index,
              type: 1,
              list: _this.videoResourceIdList,
              fileList: _this.videoList,
            });
            file.url = res.url;
            file.id = res.resourceId;
            file.status = "done";
            file.message = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        }
      );
    },
    /* 上传视频 自行将文件上传至服务器 */
    afterVideoRead(file) {
      var _this = this;
      if (file instanceof Array) {
        for (var i = 0; i < file.length; i++) {
          let item = file[i];
          item.status = "uploading";
          item.message = "上传中...";
          _this.uploadVideo(item);
        }
      } else {
        file.status = "uploading";
        file.message = "上传中...";
        _this.uploadVideo(file);
      }
      _this.$emit("uploadData", {
        index: _this.index,
        type: 1,
        list: _this.videoResourceIdList,
        fileList: _this.videoList,
      });
    },
    /* 移除视频 */
    deleteVideo(file) {
      var _this = this;
      var index = _this.videoResourceIdList.indexOf(file.id);
      if (index > -1) {
        _this.videoResourceIdList.splice(index, 1);
        _this.videoList.splice(index, 1);
        _this.$emit("uploadData", {
          index: _this.index,
          type: 1,
          list: _this.videoResourceIdList,
          fileList: _this.videoList,
        });
      }
    },
    /* 视频预览 */
    previewVideoHandler(file) {
      var _this = this;
      if (!!file.status && file.status == "uploading") {
        return
      } else {
        _this.showVideo = true;
        _this.videoSrc = file.url;
      }
    },
    /* 音频预览 */
    previewAudioHandler(file) {
      var _this = this;
      if (!!file.status && file.status == "uploading") {
        return
      } else {
        _this.showAudio = true;
        _this.audioSrc = file.url;
      }
    },
    /* 关闭视频预览 */
    closeVideo() {
      var _this = this;
      _this.showVideo = false;
      _this.videoSrc = "";
    },
    /* 关闭音频预览 */
    closeAudio() {
      var _this = this;
      _this.showAudio = false;
      _this.audioSrc = "";
    },
  },
  created() {
    UploadServer.startUpload();
  },
  destroyed() {
    UploadServer.stopUpload();
  }
};
</script>
<style scoped lang="scss">
.file_upload_box {
  .video_upload,
  .audio_upload {
    /deep/.van-icon-description {
      display: none;
    }
    /deep/.van-uploader__file-name {
      display: none;
    }
    .preview-cover {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      .van-icon {
        position: absolute;
        left: 25px;
        top: 25px;
        font-size: 30px;
        color: #fff;
      }
    }
  }
}
.video_preview_dialog {
  position: fixed;
  top: 12.4vw;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: calc(100% - 12.4vw);
  padding-top: 12.4vw;
  background-color: rgba(0, 0, 0, 0.9);
  .video_preview_box {
    position: relative;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    overflow: hidden;
    video {
      display: block;
      object-fit: contain;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.audio_preview_dialog {
  position: fixed;
  top: 12.4vw;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: calc(100% - 12.4vw);
  padding-top: 12.4vw;
  background-color: rgba(0, 0, 0, 0.9);
  .audio_preview_box {
    position: relative;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    overflow: hidden;
    audio {
      display: block;
      object-fit: contain;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>